
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import LocationSection from './components/LocationSection';
import SpecificationsSection from './components/SpecificationsSection';
import NewsletterSection from './components/NewsletterSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <AboutSection />
      <FeaturesSection />
      <LocationSection />
      <SpecificationsSection />
      <NewsletterSection />
      <ContactSection />
    </div>
  );
}
